import ResponsiveImage from "../components/common/ResponsiveImage";
import { tr, usePartnerTranslation } from "../lib/language";
import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";
import { SUPPLIER_LOGO } from "../lib/constants";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/auth`;

export default function AcceptInvitePage() {
  usePartnerTranslation();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const navigate = useNavigate();
  const { login } = useAuth();

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (password.length < 8) {
      setError(tr("Password must be at least 8 characters."));
      return;
    }
    if (password !== confirm) {
      setError(tr("Passwords do not match."));
      return;
    }

    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/invite/accept`, { token, password });
      login({ user: data.user });
      toast.success(tr("Welcome to Voocly! Your account is ready."));
      navigate("/home");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : tr("Something went wrong. The link may have expired."));
    } finally {
      setBusy(false);
    }
  };

  if (!token) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-sm text-[#6B7280]">{tr("Invalid invite link.")}</p>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#FAFAFB] px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex justify-center">
          <ResponsiveImage imageWidth={960} src={SUPPLIER_LOGO} alt="Voocly" className="h-10 w-auto" />
        </div>

        <div className="rounded-2xl border border-[#EAECEF] bg-white p-8 shadow-sm">
          <h1 className="text-xl font-extrabold tracking-tight text-[#0F1115]">{tr("Set your password")}</h1>
          <p className="mt-1 text-sm text-[#6B7280]">{tr("Choose a password to activate your Voocly account.")}</p>

          <form onSubmit={handleSubmit} className="mt-6 space-y-4">
            <div>
              <label className="mb-1.5 block text-sm font-semibold text-[#0F1115]">{tr("Password")}</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder={tr("Min. 8 characters")}
                autoFocus
                className="humrahe-input"
                data-testid="invite-password"
              />
            </div>

            <div>
              <label className="mb-1.5 block text-sm font-semibold text-[#0F1115]">{tr("Confirm password")}</label>
              <input
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                placeholder={tr("Repeat your password")}
                className="humrahe-input"
                data-testid="invite-confirm"
              />
            </div>

            {error && (
              <p className="text-sm font-medium text-[#9B0000]" data-testid="invite-error">
                {error}
              </p>
            )}

            <button
              type="submit"
              disabled={busy}
              data-testid="invite-submit"
              className="humrahe-btn-primary mt-2 h-10 w-full rounded-md text-sm font-semibold disabled:opacity-60"
            >
              {busy ? tr("Activating…") : tr("Activate account")}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
